/* ============================================================
   RHODE MOTION — scroll reveals
   Pure IntersectionObserver, no library. Progressive enhancement:
   if this script never runs, nothing is hidden and the page is
   completely normal (the hidden state is gated behind the
   .rhode-motion class this script adds).
   ============================================================ */
(function () {
  var root = document.documentElement;

  // Respect the user's OS-level motion preference.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  root.classList.add('rhode-motion');

  // Containers whose children should appear one after another.
  var STAGGER = [
    '.pc-ingredients__grid',
    '.pc-howto__grid',
    '.pc-routine__grid',
    '.pc-benefit__grid',
    '.collection-list__list'
  ].join(',');

  var STAGGER_STEP = 70; // ms between children
  var STAGGER_MAX = 6;   // stop compounding after this many

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
  );

  function prepare(scope) {
    var main = (scope || document).querySelector('main') || document;

    // Reveal each section as it scrolls in. The first section is skipped
    // so the hero paints immediately (protects LCP on ad traffic).
    var sections = main.querySelectorAll('main > .shopify-section, .shopify-section');
    Array.prototype.forEach.call(sections, function (section, index) {
      if (section.hasAttribute('data-rhode-reveal')) return;
      if (index === 0 && !scope) return;
      if (section.closest('.swiper-wrapper')) return;

      section.setAttribute('data-rhode-reveal', '');
      observer.observe(section);
    });

    // Stagger the children of known grids.
    var grids = (scope || document).querySelectorAll(STAGGER);
    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.hasAttribute('data-rhode-stagger')) return;
      grid.setAttribute('data-rhode-stagger', '');

      Array.prototype.forEach.call(grid.children, function (child, i) {
        var step = Math.min(i, STAGGER_MAX);
        child.style.transitionDelay = step * STAGGER_STEP + 'ms';
      });

      observer.observe(grid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prepare(); });
  } else {
    prepare();
  }

  // Theme editor: re-prepare sections as they are re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    prepare(event.target);
  });
})();
